export default {
  "create-success": {
    EN: "Successfully created new notification triggger.",
  },
  "create-failure": {
    EN: "Failed to create notification triggger. Please try again later.",
  },
  "update-success": {
    EN: "Successfully updated  notification triggger.",
  },
  "update-failure": {
    EN: "Failed to update notification triggger. Please try again later.",
  },
};
